import { get } from "lodash";

export const buildLaunchDarklyUser = (userData, orgData) => {
  // get pertinent values from
  // current blumira user
  const { id: userId, first_name, last_name, superadmin = false } = userData;

  // get pertinent values from
  // current blumira org
  const { id: orgId, market } = orgData;

  // get license to avoid edge cases where
  // blumira org has undefined config
  const license = get(orgData, ["config", "license"], "ADVANCED");

  // build and format user/org data
  // for launch darkly client
  const launchDarklyUserDataToReturn = {
    key: `person-${userId}`,
    name: `${first_name} ${last_name}`,
    custom: {
      org_id: orgId,
      edition: license,
      person_id: userId,
      is_superadmin: superadmin,
      market: market,
      // add role_id here
    },
  };

  return launchDarklyUserDataToReturn;
};
